import Vue from "vue";
import Vuex from "vuex";

import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket';

const logrocketPlugin = createPlugin(LogRocket);

import api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [logrocketPlugin],
  state: {
    // user: localStorage.getItem("user"),
    // token: localStorage.getItem("token") || "",
    // status: null,
    company: JSON.parse(localStorage.getItem("company") == "undefined" ? null : localStorage.getItem("company")),
    projects: [],
    statuses: JSON.parse(localStorage.getItem("statuses") == "undefined" ? null : localStorage.getItem("statuses")),
    user: JSON.parse(localStorage.getItem("user") == "undefined" ? null : localStorage.getItem("user")),
    userData: {},
    company_type: JSON.parse(localStorage.getItem("company_type") == "undefined" ? null : localStorage.getItem("company_type")),
    // fakeLicense: true
  },
  getters: {
    // companyProjectsCount: state => state.companyProjects.length,
    isAuthenticated: state => state.user !== null,
    isAdmin: state => state.user.admin,
    company: state => state.company,
    // needsLicense: state => state.user == null ? null : state.user.days_left_in_trial < -30
    // needsLicense: state => state.fakeLicense
  },
  mutations: {
    setProjects(state, projects) {
      console.log("inside setProjects");
      // update products
      state.projects = projects;
      console.log(state.projects);
    },
    setProject(state, item) {
      state.projects.push(item);
    },
    setUsers(state, users) {
      state.users = users;
    },
    setUser(state, user) {
      console.log(user)
      state.user = user.user;
      state.company = user.companies[0];
      state.statuses = user.all_statuses;
      state.company_type = {'user_type': user.company_user};
      localStorage.setItem("statuses", JSON.stringify(user.all_statuses));
      localStorage.setItem("user", JSON.stringify(user.user));
      localStorage.setItem("company", JSON.stringify(user.companies[0]));
      localStorage.setItem('jwt-secret-sauce', JSON.stringify(user.jwt));
      localStorage.setItem('company_type', JSON.stringify({'user_type': user.company_user}));
	    LogRocket.identify(user.user.id.toString(), {
		    name: user.user.full_name,
		    email: user.user.email
	    });
      //LogRocket.identify(user.user.id, {
	     // name: user.user.full_name,
	     // email: user.user.email
      //}); 
    },
    setUserData(state, userData) {
      console.log(userData);
      console.log("here!");
      localStorage.setItem("user", JSON.stringify(userData.user));
      state.user = JSON.parse(localStorage.getItem("user"));
    },
    clearUser(state) {
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("company");
      localStorage.removeItem("jwt-secret-sauce");
      localStorage.removeItem("company");
      localStorage.removeItem("company_type");
      localStorage.removeItem("statuses");
      state.company_type = null;
      state.company = null;
    },
    setCompany(state, company){
      console.log(company);
      state.company = company;
      state.company_type = 'owner';
      localStorage.setItem("company_type", JSON.stringify({'user_type': 'owner'}))
      localStorage.setItem("company", JSON.stringify(company));
    },
    updateUser(state, userData) {
      localStorage.setItem("user", JSON.stringify(userData.user))
      state.user = JSON.parse(localStorage.getItem("user"))
    }
  },
  actions: {
    signIn({ commit }, { user }) {
      return new Promise((resolve, reject) => {
        api
          .signInUser(user)
          .then((response) => {
            console.log(response);
      	    var user = {
              ...response.data,
      	      jwt: response.headers.authorization
      	    }
            commit("setUser", user);
            resolve();
          })
          .catch((error) => {
            // if the request fails, clear user
            console.log('in store')
            console.log(error)
            console.log(error);
            commit("clearUser");
            reject(error);
          });
      });
    },
    signUp({ commit }, { user }) {
      return new Promise((resolve, reject) => {
        api
          .createUser(user)
          .then((response) => {
            resolve();
          })
          .catch((e) => {
            // commit("clearUser");
            // console.log(error.response);
            reject(e.data.errors);
          });
      });
    },
    createUser({ commit }, { user }) {
      return new Promise((resolve, reject) => {
        api
          .addUser(user)
          .then((response) => {
            resolve();
          })
          .catch((e) => {
            // commit("clearUser");
            // console.log(error.response);
            reject(e.data.errors);
          });
      });
    },
    signOut({ commit }) {
      // The Promise used for router redirect in Header.vue
      return new Promise((resolve) => {
        api.deleteSession().then(() => {
          commit("clearUser");
          resolve();
        });
      });
    },
    getUserDataForProfile(context) {
      // console.log(context.state.user);
      return new Promise((resolve) => {
        api.getUserData(context.state.user.id).then((response) => {
          context.commit("setUserData", response.data);
          console.log(response);
          resolve();
        });
      });
    },
    updateUserData(context, newUserData) {
      return new Promise((resolve) => {
        api.updateUserData(newUserData).then((response) => {
          console.log(response);
          context.commit("setUserData", response.data)
          resolve();
        });
      });
    },
    saveUserSig(context, sigData){
      return new Promise((resolve) => {
        api.saveUserSig(sigData).then((response)=> {
          console.log(response);
          context.commit("setUserData", response.data)
        })
      })
    },
    getProjects(context) {
      return new Promise((resolve) => {
        api.getProjects().then((response) => {
          // context.commit("setProjects", response.data);
        });
      });
    },
    addCompany(context, reqObj) {
      return new Promise((resolve) => {
        api.addNewCompany(reqObj[0], reqObj[1]).then((response) => {
          console.log(response.data);
          context.commit("setCompany", response.data);
          resolve();
        })
      })
    },
    submitQuiz(context, data) {
      return new Promise((resolve) => {
        api.submitQuiz(data).then((response) => {
          context.commit("updateUser", response.data);
          resolve();
        })
      })
    }
  },
});
